export default __webpack_public_path__ + "static/media/portugal.96475126.svg";